module.exports = __webpack_public_path__ + "img/avatar0.b1357d51.png";